import { useContext } from 'react'
import { ModalContext } from './ModalContext'

/**
 *
 * @param {useModal} function
 * hook for showing and hiding modals
 * @param {component} <Component />
 * @returns An array of functions for showing and hiding
 * the passed in modal component
 *
 * Note: when shown, ModalProvider clones the passed-in component with
 * `visible`, `onOk`, and `onCancel` props (see ModalProvider.js). The
 * modal component must accept and forward these (typically via
 * `{...rest}` spread onto its root <Modal>) or the modal won't render
 * (antd's Modal defaults `visible` to false) and Cancel/close won't work.
 */
export const useModal = component => {
  const { setModal } = useContext(ModalContext)
  const showModal = () => setModal(component)
  const hideModal = () => setModal(null)
  return [showModal, hideModal]
}
